import type { Organization } from "@/features/auth/types/organization.type";
import type { DashboardLayoutResponse } from "@/features/dashboard/types/dashboardLayout";
import type { BrandThemeData } from "@/features/theme/types/brandTheme.type";

/**
 * Builds a BrandThemeData from the legacy fragmented sources:
 * - colors/banners/vouchers from organization.theme_config
 * - navigation_position from organization
 * - dashboard_layout from a separate API call
 */
export const buildFallbackTheme = (
  organization: Organization | null,
  dashboardLayout: DashboardLayoutResponse | null | undefined,
): BrandThemeData | null => {
  if (!organization) return null;

  return {
    colors: organization.theme_config?.colors ?? null,
    banners: organization.theme_config?.banners ?? null,
    vouchers: organization.theme_config?.vouchers ?? null,
    navigationPosition: organization.navigation_position,
    dashboardLayout: dashboardLayout ?? null,
    menu: null,
  };
};
